
import tools_log           from './tools_log'                   // log 관련

import tools_base          from './base.1.tools_isnull'          // 타입상관 없이 null 체크 같은 기본
import tools_string_number from './base.2.tools_string_number'   // string, number 관련
import tools_array         from './base.3.tools_array'           // array 관련
import tools_object        from './base.4.tools_map_object'      // map 형태 object
import tools_alert_noti    from './tools_alert_noti'             // alert, confirm, prompt, notify
import tools_move_input    from './tools_move_input'             // 포커스 자동이동. nextFocus, nextSelect
import tools_http          from './tools_http'                   // 포커스 자동이동. nextFocus, nextSelect
import tools_web           from './tools_web'                    // 웹브라우져 관련
import tools_stable        from './tools_stable'                 // stable관련
import tools_misc          from './tools_misc'                   // 기타 잡다
import tools_vue           from './tools_vue'                    // vue 전용

export default {
  ...tools_log,

  ...tools_base,
  ...tools_string_number,
  ...tools_array,
  ...tools_object,
  ...tools_alert_noti,
  ...tools_move_input,
  ...tools_http,
  ...tools_web,
  ...tools_stable,
  ...tools_misc,
  ...tools_vue,
}


